// AUTO-GENERATED by page-builder-gen — do not edit
import type { BuilderManifest } from '@jht/brand-page-builder/core';

export const BUILDER_MANIFEST: BuilderManifest = {
  components: [
  {
    type: "CardComponent",
    load: () => import("./shared/components/card/card.component").then((m) => m.CardComponent)
  },
  {
    type: "CarouselComponent",
    load: () => import("./shared/components/carousel/carousel.component").then((m) => m.CarouselComponent)
  },
  {
    type: "CarouselEquipmentComponent",
    load: () => import("./shared/components/carousel-equipment/carousel-equipment.component").then((m) => m.CarouselEquipmentComponent)
  },
  {
    type: "CarouselProgressComponent",
    load: () => import("./shared/components/carousel-progress/carousel-progress.component").then((m) => m.CarouselProgressComponent)
  },
  {
    type: "CTAComponent",
    load: () => import("./shared/components/cta/cta.component").then((m) => m.CTAComponent)
  },
  {
    type: "GlobalMarketsComponent",
    load: () => import("./shared/components/global-markets/global-markets.component").then((m) => m.GlobalMarketsComponent)
  },
  {
    type: "InlineBannerComponent",
    load: () => import("./shared/components/inline-banner/inline-banner.component").then((m) => m.InlineBannerComponent)
  },
  {
    type: "SideBySideComponent",
    load: () => import("./shared/components/side-by-side/side-by-side.component").then((m) => m.SideBySideComponent)
  },
  {
    type: "TopBannerComponent",
    load: () => import("./shared/components/top-banner/top-banner.component").then((m) => m.TopBannerComponent)
  }
  ],
  editor: () => import("./builder.manifest.editor").then((m) => m.EDITOR_MANIFEST),
};
